// Read ?checkout=starter&add_ons=a,b (the link in the "checkout didn't
// complete" email) into the add-ons to pre-tick. Null when the URL asks for no
// checkout. Only what we sell is accepted; the URL is user-typed input.
const SOLD = ['white_label', 'expert_call'];

export function checkoutFromSearch(search) {
  const params = new URLSearchParams(search || '');
  if ((params.get('checkout') || '').toLowerCase() !== 'starter') return null;
  const asked = (params.get('add_ons') || '').split(',');
  return Object.fromEntries(SOLD.map((k) => [k, asked.includes(k)]));
}

// The add-ons a resumed checkout had, from the server, as the popup's shape.
export function addOnsFrom(saved) {
  return Object.fromEntries(SOLD.map((k) => [k, Boolean(saved && saved[k])]));
}

// A promo covers the whole order (owner, 2026-10-07), or with applies_to
// 'audit' the plan only, the first price (owner, 2026-10-09). Each line to the
// cent, the same rule as backend pricing.usd_lines, so the total shown is the
// total PayPal charges.
export function linePrices(prices, percent, appliesTo) {
  return prices.map((p, i) => {
    const off = appliesTo === 'audit' && i > 0 ? 0 : (percent || 0);
    return [p, Math.round(p * (100 - off)) / 100];
  });
}

export function discountedUsd(prices, percent, appliesTo) {
  const cents = linePrices(prices, percent, appliesTo).reduce((sum, [, after]) => sum + Math.round(after * 100), 0);
  return cents / 100;
}

export function fmtUsd(amount) {
  const cents = Math.round(amount * 100);
  return cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
}
